var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56Z",
    fill: "#DB5757"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1448 26.9095C17.8934 27.1955 17.8403 27.6054 18.0106 27.9459L18.9606 29.8459C19.1192 30.163 19.4432 30.3633 19.7977 30.3633L22.2189 30.3633C22.6517 30.3633 23.028 30.0666 23.129 29.6458L23.5632 27.8363C23.8662 26.5739 24.9951 25.6839 26.2933 25.6839L29.7059 25.6839C31.0041 25.6839 32.133 26.5739 32.436 27.8363L32.8703 29.6458C32.9713 30.0666 33.3476 30.3633 33.7803 30.3633L36.2015 30.3633C36.556 30.3633 36.8801 30.163 37.0386 29.8459L37.9886 27.9459C38.1589 27.6054 38.1059 27.1955 37.8545 26.9095C36.6367 25.5241 33.3321 24.748 27.9996 24.748C22.6672 24.748 19.3625 25.5241 18.1448 26.9095ZM16.7389 25.6738C18.4271 23.7532 22.161 22.8763 27.9996 22.8763C33.8382 22.8763 37.5721 23.7532 39.2603 25.6738C40.0145 26.5318 40.1736 27.7613 39.6627 28.783L38.7128 30.683C38.2372 31.6342 37.265 32.235 36.2015 32.235L33.7803 32.235C32.4821 32.235 31.3532 31.345 31.0502 30.0826L30.6159 28.2731C30.5149 27.8523 30.1386 27.5556 29.7059 27.5556H26.2933C25.8606 27.5556 25.4843 27.8523 25.3833 28.2731L24.949 30.0826C24.6461 31.345 23.5171 32.235 22.2189 32.235L19.7977 32.235C18.7343 32.235 17.7621 31.6342 17.2865 30.683L16.3365 28.783C15.8256 27.7613 15.9847 26.5318 16.7389 25.6738Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReject);
export default __webpack_public_path__ + "static/media/reject.63ad3fa3bb1919991f0f96c6649fabeb.svg";
export { ForwardRef as ReactComponent };